module.exports = __webpack_public_path__ + "static/Rowdy-2bd29f9f62e96c780017169265187849.jpg";